


<template>
	<div>
		<panel title="Информация об исполнителе">
			<div class="card  border-0 mb-3">
				<table class="table">
					<tbody>
						<tr>
							<td>Аватар</td>
							<td>
								<img :src="`/images/avatar/` + user.avatar" class="w-250px rounded-3">
							</td>
						</tr>
						<tr>
							<td>ID</td>
							<td>{{ user.id }}</td>
						</tr>
						<tr>
							<td>Имя</td>
							<td>{{ user.name }}</td>
						</tr>
						<tr>
							<td>Рейтинг</td>
							<td>{{ user.rating }}</td>
						</tr>
						<tr>
							<td>Рефер</td>
							<td>{{ user.ref_id }}</td>
						</tr>
						<tr>
							<td>Баланс</td>
							<td>{{ user.balance }}</td>
						</tr>
						<tr>
							<td>Заработано всего</td>
							<td>{{ user.balance_earn }}</td>
						</tr>
						<tr>
							<td>Заработано сегодня</td>
							<td>{{ user.balance_day }}</td>
						</tr>
						<tr>
							<td>Заработано на рефералах</td>
							<td>{{ user.balance_ref }}</td>
						</tr>
						<tr>
							<td>Email</td>
							<td>{{ user.email }}</td>
						</tr>
						<tr>
							<td>Дата регистрации</td>
							<td>{{ user.created_at }}</td>
						</tr>
						<tr>
							<td>Дата активности</td>
							<td>{{ user.updated_at }}</td>
						</tr>
					</tbody>
				</table>
			</div>


			<!-- END panel -->
			<table class="table">
				<tbody>
					<tr v-for="mesg in user.messages" v-bind:key="mesg.id" style="vertical-align: middle;">
						<td>{{ mesg.message }}</td>
						<td>
							<div v-for="img in mesg.images" v-bind:key="img.id">

								<img :src="`/images/screen/` + img.name" class="w-250px rounded-3">
							</div>

						</td>
					</tr>
				</tbody>
			</table>

			<select v-model="message" class="form-select mb-1 ">
				<option v-for="(message, index)  in messages" :key=index :value="message">
					{{ message }}
				</option>
			</select>

			<textarea v-model="message" class="form-control" rows="6"></textarea>
			<div class="d-flex justify-content-end">
				<div class="btn btn-primary m-1" @click="banUser()">Бан</div>
			</div>
		</panel>
	</div>
</template>


<script>
import HTTP from "../http";
import { show_error, show_message } from "../message";


export default {

	data() {
		return {
			loading: false,
			errors: null,
			title: null,
			messages: ['отправка ложных отчетов,  раздел 3, пункт 15 правил.', 2, 3],
			message: 'отправка ложных отчетов,  раздел 3, пункт 15 правил.',
			user: {}
		};
	},

	created() {
		let id = this.$route.params.id || 0
		console.log('id', id)

		this.fetchData(id)
	},

	methods: {

		banUser() {
			this.$insProgress.start();
			this.loading = true;
			HTTP()
				.put(`/user_ban/${this.user.id}`, { message: this.message })
				.then((resp) => {
					console.log(resp.data)
					show_message(this.$notify, JSON.stringify(resp.data))
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
		fetchData(id) {
			this.loading = true;
			this.$insProgress.start();

			HTTP()
				.get(`/admin_payout/${id}`)
				.then((resp) => {
					console.log('resp', resp)
					this.user = resp.data;
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},

	}
}

</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}
</style>
 
